import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    NotificationClient,
    NotificationView,
    NotificationViewPaginatedResultDto,
    SearchNotificationsParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private readonly client: NotificationClient) {}

    async search(body: SearchNotificationsParameters): Promise<NotificationViewPaginatedResultDto> {
        return await lastValueFrom(this.client.notificationSearch(body));
    }

    async getLatest(): Promise<NotificationView[]> {
        return await lastValueFrom(this.client.notificationGetLatestForCurrentUser());
    }

    async markAsRead(id: number): Promise<void> {
        await lastValueFrom(this.client.notificationMarkAsRead(id));
    }

    async markAllAsRead(): Promise<void> {
        await lastValueFrom(this.client.notificationMarkAllAsRead());
    }
}
